<template>
  <div class="wrapper w-mb2">
    <div class="inp-group" v-for="(item, index) in block.data.items" :key="index">
      <input class="inp-group__checkbox" type="checkbox" disabled="disabled" :checked="!!item.checked"  />
      <label><span class="checkbox"></span><span>{{ item.text }}</span></label>
    </div>
  </div>
</template>
<script>
export default {
  name: "ChecklistBlock",
  props: ["block"],
};
</script>
<style lang="scss" scoped>
input[type="checkbox"] {
  appearance: auto;
}
</style>
